:host {
  display: contents;
}

/* ---------- Body layout ----------- */

.body {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  gap: var(--spacing-5);
  min-height: 260px;
  padding: var(--spacing-6) 0;
}

.body--error {
  min-height: 0;
  gap: 20px;
}

.body--fields-open {
  min-height: 0;
  gap: 20px;
}

.intro {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
}

.setup-grid {
  flex: 1;
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: var(--spacing-6);
  min-height: 184px;
}

.left-column {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  min-width: 0;
}

.left-column inmar-hc-upload-area-drag {
  width: 100%;
}

.right-column {
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 0;
}

.download-btn-wrapper {
  padding-bottom: var(--spacing-4);
  border-bottom: 1px solid var(--color-gray-200);
}

.download-btn-wrapper inmar-hc-button {
  display: block;
}

.download-btn-wrapper inmar-hc-button::part(button) {
  width: 100%;
  box-sizing: border-box;
}

.download-btn-wrapper hcds-icon {
  width: 20px;
  height: 20px;
  font-size: 20px;
}

/* ---------- Section headings ----------- */

.section-title {
  margin: 0;
  font-family: var(--font-sans);
  font-size: var(--text-base);
  font-weight: var(--font-weight-bold);
  color: var(--color-gray-900);
  line-height: var(--leading-snug);
  letter-spacing: var(--tracking-normal);
}

.section-subtitle {
  margin: 0;
  font-family: var(--font-sans);
  font-size: var(--text-sm);
  color: var(--color-gray-900);
  line-height: var(--leading-normal);
}

/* ---------- Required fields ----------- */

.required-fields {
  padding-top: var(--spacing-4);
}

.required-fields-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 0 var(--spacing-3);
  font-family: var(--font-sans);
  font-size: var(--text-base);
  font-weight: var(--font-weight-normal);
  color: var(--color-gray-900);
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
}

.required-fields-header:hover {
  color: var(--color-gray-900);
}

.required-fields-header:focus-visible {
  outline: 2px solid var(--color-primary-600);
  outline-offset: 2px;
  border-radius: var(--radius-sm);
}

.required-fields-header:focus:not(:focus-visible) {
  outline: none;
}

/* ---------- Required-fields chevron ----------- */

.chevron {
  color: var(--color-gray-500);
  flex-shrink: 0;
  transition: transform 200ms ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}

.chevron hcds-icon {
  width: 20px;
  height: 20px;
  display: block;
  color: inherit;
}

.chevron.open {
  transform: rotate(180deg);
}

/* ---------- Required fields body ----------- */

.required-fields-body {
  display: none;
}

.required-fields-body.open {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
}

.required-fields-field {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  overflow: hidden;
}

.required-fields-field-name {
  margin: 0;
  font-family: var(--font-sans);
  font-size: var(--text-base);
  font-weight: var(--font-weight-medium);
  color: var(--color-gray-900);
}

.required-fields-field-description {
  margin: 0;
  font-family: var(--font-sans);
  font-size: var(--text-sm);
  color: var(--color-gray-500);
}

/* ---------- File selected indicator ----------- */

.file-selected-indicator {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-1);
  min-width: 0;
}

.file-selected-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-primary-800);
  flex-shrink: 0;
}

.file-selected-name {
  font-family: var(--font-sans);
  font-size: var(--text-base);
  font-weight: var(--font-weight-semibold);
  color: var(--color-primary-800);
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.file-selected-indicator inmar-hc-button::part(button):hover {
  background: transparent;
}

/* ---------- Processing indicator ----------- */

.processing-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-2);
  min-height: 184px;
  text-align: center;
}

@media (max-width: 640px) {
  .setup-grid {
    grid-template-columns: 1fr;
    min-height: 0;
  }
}
